module.exports = __webpack_public_path__ + "static/media/m_buy_03.31bb97a9.jpg";